
export default {
    namespaced: true,
    state: {        
        loading: false        
    },
    getters: {      
        'loading': state => state.loading,

    },
    mutations: {        
        'SET_LOADING': (state, isLoading) => {
            state.loading = isLoading
        }
    },
    actions: {        
        'SET_LOADING': ({commit}, isLoading) => {
            commit("SET_LOADING", isLoading);
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/UI.js